export default __webpack_public_path__ + "static/media/success-noti.a9d909ed.svg";